class AriaNav {
  constructor() {
    this.currentPage = document.querySelector(".current-menu-item");
    this.events();
  }

  events() {
    document.body.addEventListener("onload", () => this.toggleAria());
  }

  toggleAria() {
    if (currentPage) {
      this.setAttribute("aria-current", "page");
    }
  }
}

export default AriaNav;